import { clsx } from 'clsx';
import styles from './ScenarioCard.module.css';

export function ScenarioCard({
  title,
  probability,
  priorProbability,
  signal,
  description,
  selected = false,
  onSelect,
}: {
  title: string;
  probability: number;
  priorProbability?: number;
  signal: 'base' | 'upside' | 'downside';
  description: string;
  selected?: boolean;
  onSelect?: () => void;
}) {
  const delta =
    priorProbability !== undefined ? probability - priorProbability : null;

  return (
    <button
      type="button"
      className={clsx(
        styles.root,
        selected && styles.selected,
        signal === 'upside' && styles.upside,
        signal === 'downside' && styles.downside,
      )}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className={styles.top}>
        <strong>{title}</strong>
        <b className={styles.probability}>{probability}%</b>
      </span>
      <span className={styles.bar}>
        <span className={styles.barFill} style={{ width: `${probability}%` }} />
      </span>
      <span>{description}</span>
      {priorProbability !== undefined && delta !== null && (
        <small className={styles.prior}>
          Prior {priorProbability}% · Δ {delta > 0 ? '+' : ''}
          {delta}pp
        </small>
      )}
    </button>
  );
}
